import React, { useEffect, useState } from "react";
import "./style.css";
import AdminPassengerDetail from "../../AdminPassengerDetail";
import { adminEditStatus, convertToGMT, getBookingFormatedDateMonthValue, getBookingFormatedValue, calcFareValues, getTimeDistanceDifference, isTravelDateGreaterThanPointTime } from "../../../../utils/Functions";
import { checkSeatAvailabilityCategory, getEstimateFareByData, postSaveMTripCategory, getCityData } from "../../../../utils/api.functions";
import { toast } from "react-toastify";
import { delayData, FARE_ADVANCE_COMMISSION_PERCENT, FARE_PLATFORM_FEE_PERCENT, FARE_GST_PERCENT, CITY_ID } from "../../../../utils/common.data";
import { useParams } from "react-router-dom";

const AdminBoardingItem = ({ selectedValue, busSelect, fetchCategories, handleApiRedirect, tripDetail, onEstimateFareLoaded }) => {
  const params = useParams()
  const apiKey = sessionStorage.getItem("key");
  const [book, setBook] = useState(false);
  const [view, setView] = useState(0);
  const [boardingSelection, setBoardingSelection] = useState(null);
  const [droppingSelection, setDroppingSelection] = useState(null);
  const [activeTab, setActiveTab] = useState("boarding"); // "boarding" or "dropping"
  const [mTripID, setMtripID] = useState("");
  const [selectedVal, setSelectedVal] = useState(selectedValue)
    const [searchDetail, setSearchDetail] = useState({
      boarding: "",
      dropping: "",
      travel_date: "",
    });
  const [estimPriceList, setEstimPriceList] = useState(null);
  const [companyId, setCompanyId] = useState(1);
  const [cityTax, setCityTax] = useState(FARE_GST_PERCENT);

  useEffect(() => {
    setCompanyId(busSelect?.driver?.company_id || 1);
  }, [busSelect]);

  useEffect(() => {
    const fetchCityTax = async () => {
      try {
        const response = await getCityData({ city_id: CITY_ID }, apiKey);
        if (response.status === 200) {
          const tax = Number(response.data.response?.[0]?.city_tax);
          if (tax > 0) setCityTax(tax);
        }
      } catch (e) {
        console.log("City tax fetch error:", e);
      }
    };
    fetchCityTax();
  }, []);

  const isPremium = parseInt(companyId) > 1;

  useEffect(() => {
    const fetchEstimate = async () => {
      if (!searchDetail?.boarding || !searchDetail?.dropping || !busSelect?.category_id) return;
      try {
        const data = {
          trip_from_loc: searchDetail.boarding,
          trip_to_loc: searchDetail.dropping,
          trip_date: convertToGMT(new Date(searchDetail.travel_date || busSelect?.departure)),
          trip_hrs: getTimeDistanceDifference(new Date(busSelect?.departure), new Date(busSelect?.arrival)),
          city_id: CITY_ID,
          user_id: sessionStorage.getItem("userid"),
          seats: filterSelectedSeat(selectedValue)?.length || 1,
          is_share: 0,
          polyline: "0",
          amount: totalAmountCal(selectedValue),
        };
        const result = await getEstimateFareByData(data, apiKey);
        if (result?.status === 200 && result?.data?.resDecrypt?.response) {
          setEstimPriceList(result.data.resDecrypt.response);
          const est = result.data.resDecrypt.response[busSelect?.category_id];
          if (est && onEstimateFareLoaded) {
            const isPremium = parseInt(companyId) > 1;
            onEstimateFareLoaded(calcFareValues(Number(est?.trip_base_fare) || 0, isPremium ? FARE_PLATFORM_FEE_PERCENT : 0, isPremium ? cityTax : 0));
          }
        }
      } catch (e) {
        console.log("Estimate fetch error:", e);
      }
    };
    fetchEstimate();
  }, [searchDetail?.boarding, searchDetail?.dropping, busSelect?.category_id, selectedValue]);
  
    useEffect(() => {
      const searchData = sessionStorage.getItem("bookingdetails");
      if (searchData) {
        try {
          const searchValue = JSON.parse(searchData);
          setSearchDetail({
            ...searchDetail,
            ...searchValue,
            travel_date: searchValue?.date,
          });
        } catch (error) {
          console.log(`search Data Err`, error);
        }
      }
    }, []);

  useEffect(() => {
    if (params?.id && tripDetail?.customer_details?.customer) {
      // Assuming each customer has a unique seatId and seatType
      // const boardingData = tripDetail?.customer_details?.boarding;
      // const droppingData = tripDetail?.customer_details?.dropping;

      // setBoardingSelection(boardingData?.id)
      // setDroppingSelection(droppingData?.id)
      setView(0)
      if(adminEditStatus.includes(tripDetail?.trip_status)){
        setBook(true)
      }
    }

  }, [tripDetail, params?.id])

  const handleBoardingChange = (e) => {
    setBoardingSelection(e.target.value);
    setActiveTab("dropping");
  };

  const handleDroppingChange = (e) => {
    setDroppingSelection(e.target.value);
  };

  useEffect(() => {
    if (selectedValue?.length !== selectedVal?.length) {
      setBook(false)
    }
  }, [selectedValue, selectedVal])

  const filterSelectedSeat = (selectedValue) => {
    return selectedValue?.filter((val) => val.selected == true);
  };

  useEffect(() => {
    getCategoryMTrip()
  }, [])

  const handleViewChange = async (val) => {
    if (val === 1) {
      try {
        const data = {
          category_id: busSelect?.category_id,          
        ...(mTripID && mTripID !== "" ? { } : {date: busSelect?.departure}),
          seats: filterSelectedSeat(selectedValue).map(
            (value) => value.seat_id
          ),
          category_time: convertToGMT(new Date(busSelect?.departure)),
          m_trip_id:mTripID
        };
        const checkValue = await checkSeatAvailabilityCategory(data, apiKey);

        if (checkValue.status == 200) {
          setView(val);
        }
      } catch (error) {
        toast.dismiss();
        toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');
        setTimeout(() => {
          window?.location?.reload()
        }, delayData.adminFormDelay);
      }
    } else {
      setView(val);
      setBook(false);
    }
  };

  const totalAmountCal = (value) => {
    if(params?.id){
      return tripDetail?.trip_base_fare
    }

    // Ensure value is an array before calling reduce
    if (!Array.isArray(value)) {
      return 0; // Return 0 if the value is not an array
    }

    return parseFloat(
      value.reduce((acc, val) => {
        // Correct the property name to 'selected' and add price if selected is true
        if (val.selected) {
          acc += val[val.seat_type]; // Add the price if selected is true
        }

        return acc; // Return the accumulated value
      }, 0)
    ).toFixed(2); // Initial accumulator value is 0
  };

  const filterSeatValue = (value) => {
    // Ensure value is an array before calling reduce
    if (!Array.isArray(value)) {
      return ""; // Return 0 if the value is not an array
    }
    // return value
    //   ?.filter((val) => val.selected)
    //   .map((cc) => cc.id)
    //   .join(" , ");
    return value
      ?.filter((val) => val.selected)
      .map((cc) => cc.id)?.length
  };

  const filterStopValue = (value) => {
    // Ensure value is an array before calling reduce
    if (!Array.isArray(value)) {
      return []; // Return 0 if the value is not an array
    }
    return value
      .map((cc) => cc)
  };


  const getCategoryMTrip = async () => {
    try {
      const response = await postSaveMTripCategory({
        category_id: busSelect?.category_id,
        category_time: convertToGMT(new Date(busSelect?.departure))
      }, apiKey);
      if (response.status === 200) {
        const value = response.data.resDecrypt.response;
        setMtripID(value)
      }
    } catch (error) {
      console.log("Create MTrip Error::", error);
    }
  };

  const handleProceed = async () => {
    try {
      const data = {
        category_id: busSelect?.category_id,
        ...(mTripID && mTripID !== "" ? { } : {date: busSelect?.departure}),
        seats: filterSelectedSeat(selectedValue).map((value) => value.seat_id),
        category_time: convertToGMT(new Date(busSelect?.departure)),
        m_trip_id:mTripID
      };
      const checkValue = await checkSeatAvailabilityCategory(data, apiKey);

      if (checkValue.status == 200) {
        setBook(true);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');
      setTimeout(() => {
        window?.location?.reload()
      }, delayData.adminFormDelay);
    }
  };

  const handleProceedClose = () => {
    setBook(false);
  };


  const handleBoardingView = (id, busSelect) => {
    //return busSelect?.boarding_points?.filter((point) => point.id == id);
    return [busSelect?.boarding_points[0]]
  };

  const handleDroppingView = (id, busSelect) => {
    //return busSelect?.dropping_points?.filter((point) => point.id == id);
    return [busSelect?.dropping_points[0]]
  };


  const handleBoardingData = (busSelect) => {
    return busSelect?.boarding_points?.sort((a, b) => {
      return new Date(a.time) - new Date(b.time);
    })
  };

  const handleDroppingData = (busSelect) => {
    return busSelect?.dropping_points?.sort((a, b) => {
      return new Date(a.time) - new Date(b.time);
    })
  };

  return (
    <>
      {/* {view === 0 && (
        <div className="booking_boarding_item_container">
          <section className="booking_boarding_item_container_item">
            <div className="booking_boarding_item_container_item_header">
              <div className="booking_boarding_item_container_item_title">
                Select the boarding & dropping point
              </div>

              <div className="booking_boarding_item_container_item_tab">
                <div
                  className={`tab ${activeTab === "boarding" ? "active" : ""}`}
                  onClick={() => setActiveTab("boarding")}
                >
                  Boarding Point
                </div>
                <div
                  className={`tab ${activeTab === "dropping" ? "active" : ""}`}
                  onClick={() => setActiveTab("dropping")}
                >
                  Dropping Point
                </div>
              </div>
            </div>

            <div className="tab_content">
              {activeTab === "boarding" && (
                <div
                  className="radio_buttons"
                >
                  {handleBoardingData(busSelect)?.map((point) => (
                    <label key={point?.id} className="radio_buttons_item">
                      <input
                        type="radio"
                        name="boarding"
                        value={point?.id}
                        checked={boardingSelection == point?.id}
                        onChange={handleBoardingChange}
                      />
                      <div className="radio_buttons_item_time">
                        {getBookingFormatedValue(new Date(point.time))}
                        {isTravelDateGreaterThanPointTime(busSelect?.arrival,busSelect?.departure) && <div className="extra_date_view">{getBookingFormatedDateMonthValue(new Date(point.time))}</div>}
                      </div>
                      <div className="radio_buttons_item_detail">
                        <div className="radio_buttons_item_detail_title">
                          {point?.title}
                        </div>
                        <div className="radio_buttons_item_detail_content">
                          {point?.descp}
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              )}
              {activeTab === "dropping" && (
                <div
                  className="radio_buttons"
                >
                  {handleDroppingData(busSelect)?.map((point) => (
                    <label key={point?.id} className="radio_buttons_item">
                      <input
                        type="radio"
                        name="dropping"
                        value={point?.id}
                        checked={droppingSelection == point?.id}
                        onChange={handleDroppingChange}
                      />

                      <div className="radio_buttons_item_time">
                        {getBookingFormatedValue(new Date(point.time))}
                        {isTravelDateGreaterThanPointTime(busSelect?.arrival,busSelect?.departure) && <div className="extra_date_view">{getBookingFormatedDateMonthValue(new Date(point.time))}</div>}
                      </div>
                      <div className="radio_buttons_item_detail">
                        <div className="radio_buttons_item_detail_title">
                          {point?.title}
                        </div>
                        <div className="radio_buttons_item_detail_content">
                          {point?.descp}
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              )}
            </div>

            <div className="continue_button">
              <div className="continue_button_content">
                <div className="continue_button_title">
                  Amount <span>(Taxes will be calculated during payment)</span>
                </div>
                <div className="continue_button_price">
                  &#8377; <span>{totalAmountCal(selectedValue)}</span>
                </div>
              </div>
              <button
                className="common_button_border"
                type="button"
                disabled={!boardingSelection || !droppingSelection}
                onClick={() => {
                  if (params?.id) {
                    setView(1)
                    return
                  }
                  handleViewChange(1);
                }}
              >
                Continue
              </button>
            </div>
          </section>
        </div>
      )} */}
      {view === 0 && (
        <section className="booking_boarding_item_process_container">
          <div className="booking_boarding_item_process_container_item">
            <div className="booking_boarding_item_process_container_item_header">
              <div className="booking_boarding_item_process_container_item_header_left">
                Boarding & Droping
              </div>
              {/* <div
                className="booking_boarding_item_process_container_item_header_right"
                onClick={() => {
                  handleViewChange(0);
                }}
              >
                Change
              </div> */}
            </div>
            <div className="booking_boarding_item_process_container_item_detail">
              <div className="dot red-dot" />
               {handleBoardingView(boardingSelection, busSelect)?.map(
                (point) => (
                  <div
                    key={point?.id}
                    className="booking_boarding_item_process_container_item_detail_board"
                  >
                    <div className="booking_boarding_item_process_container_item_detail_board_main">
                      <div className="booking_boarding_item_process_container_item_detail_board_title">
                      {busSelect?.start_location} {""}                        
                    <div className="booking_boarding_item_process_container_item_detail_board_desc">
                      {point?.descp}
                    </div>
                      </div>
                      <div className="booking_boarding_item_process_container_item_detail_board_time">
                      {getBookingFormatedValue(new Date(busSelect.departure))}
                      {/* {isTravelDateGreaterThanPointTime(busSelect?.arrival, busSelect?.departure) && <div className="extra_date_view">{getBookingFormatedDateMonthValue(new Date(busSelect?.departure))}</div>} */}
                      </div>
                    </div>
                  </div>
                )
              )}
              {/* <div
                className="booking_boarding_item_process_container_item_detail_board"
              >
                <div className="booking_boarding_item_process_container_item_detail_board_main">
                  <div className="booking_boarding_item_process_container_item_detail_board_title">
                    {busSelect?.start_location} {""}
                    <div className="booking_boarding_item_process_container_item_detail_board_desc">
                      {busSelect?.start_location_descp}
                    </div>
                  </div>
                  <div className="booking_boarding_item_process_container_item_detail_board_time">
                    {getBookingFormatedValue(new Date(busSelect.departure))}
                    {isTravelDateGreaterThanPointTime(busSelect?.arrival, busSelect?.departure) && <div className="extra_date_view">{getBookingFormatedDateMonthValue(new Date(busSelect?.departure))}</div>}
                  </div>
                </div>
              </div> */}
              <div className="vertical-line"></div>
              <div className="dot green-dot" />
              {handleDroppingView(droppingSelection, busSelect)?.map(
                (point) => (
                  <div
                    key={point?.id}
                    className="booking_boarding_item_process_container_item_detail_depart"
                  >
                    <div className="booking_boarding_item_process_container_item_detail_depart_main">
                      <div className="booking_boarding_item_process_container_item_detail_depart_title">
                      {busSelect?.end_location} {" "}                        
                    <div className="booking_boarding_item_process_container_item_detail_depart_desc">
                      {point?.descp}
                    </div>
                      </div>
                      <div className="booking_boarding_item_process_container_item_detail_depart_time">
                      {getBookingFormatedValue(new Date(busSelect?.arrival))}
                      {isTravelDateGreaterThanPointTime(busSelect?.arrival, busSelect?.departure) && <div className="extra_date_view">{getBookingFormatedDateMonthValue(new Date(busSelect?.arrival))}</div>}
                      </div>
                    </div>
                  </div>
                )
              )}
              {/* <div
                className="booking_boarding_item_process_container_item_detail_depart"
              >
                <div className="booking_boarding_item_process_container_item_detail_depart_main">
                  <div className="booking_boarding_item_process_container_item_detail_depart_title">
                    {busSelect?.end_location} {" "}
                    <div className="booking_boarding_item_process_container_item_detail_depart_desc">
                      {busSelect?.end_location_descp}
                    </div>
                  </div>
                  <div className="booking_boarding_item_process_container_item_detail_depart_time">
                    {getBookingFormatedValue(new Date(busSelect?.arrival))}
                    {isTravelDateGreaterThanPointTime(busSelect?.arrival, busSelect?.departure) && <div className="extra_date_view">{getBookingFormatedDateMonthValue(new Date(busSelect?.arrival))}</div>}
                  </div>
                </div>
              </div> */}
            </div>
            <div className="booking_boarding_item_process_container_item_fare">
            {busSelect?.cat_stopover?.length > 0 && <>
              <div className="booking_boarding_item_process_container_item_line"></div>
              <div className="booking_boarding_item_process_container_item_stops">
                <div className="booking_boarding_item_process_container_item_stops_title">
                  Stops
                </div>
                <div className="booking_boarding_item_process_container_item_stops_value">
                  {/* {filterStopValue(busSelect?.cat_stopover)} */}
                  {filterStopValue(busSelect?.cat_stopover)
          .map((stop, index, arr) => (
            <span key={stop} className="stopover-item">
              {stop.trim()}
              {index < arr.length - 1 && <span className="comma">, </span>}
            </span>
          ))}
                </div>
              </div>
            </>}
              <div className="booking_boarding_item_process_container_item_line"></div>
              <div className="booking_boarding_item_process_container_item_fare_special">
                <div className="booking_boarding_item_process_container_item_fare_special_title">
                  {/* Seat No. */}
                  Seats
                </div>
                <div className="booking_boarding_item_process_container_item_fare_special_value">
                  {filterSeatValue(selectedValue)}
                </div>
              </div>
              <div className="booking_boarding_item_process_container_item_line"></div>
              <div className="booking_boarding_item_process_container_item_fare_detail">
                Fare Details
              </div>
              {(() => {
                const baseFromEst = estimPriceList?.[busSelect?.category_id] || (tripDetail && {
                  trip_base_fare: tripDetail.trip_base_fare,
                  trip_comp_commision: tripDetail.trip_comp_commision,
                  tax_amt: tripDetail.tax_amt,
                  trip_pay_amount: tripDetail.trip_pay_amount,
                  special_fare: tripDetail.extra_charges?.specialFarePrice
                });
                const seatTotal = parseFloat(totalAmountCal(selectedValue)) || 0;
                const tripBase = seatTotal > 0 ? seatTotal : (baseFromEst?.trip_base_fare ?? 0);
                const fareValues = calcFareValues(tripBase, isPremium ? FARE_PLATFORM_FEE_PERCENT : 0, isPremium ? cityTax : 0);
                return (
                  <>
                    <div className="booking_boarding_item_process_container_item_fare_amount">
                      <div className="booking_boarding_item_process_container_item_fare_amount_title">
                        <span>Base Fare</span>
                      </div>
                      <div className="booking_boarding_item_process_container_item_fare_amount_value">
                        &#8377; {fareValues.baseFare}
                      </div>
                    </div>
                    {isPremium && (
                    <div className="booking_boarding_item_process_container_item_fare_amount">
                      <div className="booking_boarding_item_process_container_item_fare_amount_title">
                        <span>GST (5%)</span>
                      </div>
                      <div className="booking_boarding_item_process_container_item_fare_amount_value">
                        &#8377; {fareValues.gst}
                      </div>
                    </div>
                    )}
                    <div className="booking_boarding_item_process_container_item_fare_amount_divider">----------------</div>
                    <div className="booking_boarding_item_process_container_item_fare_amount">
                      <div className="booking_boarding_item_process_container_item_fare_amount_title">
                        <span>Total Fare</span>
                      </div>
                      <div className="booking_boarding_item_process_container_item_fare_amount_value">
                        &#8377; {fareValues.totalFare}
                      </div>
                    </div>
                    <div className="pay_button">
                      <button className="common_button_border" type="button" onClick={() => {
                        if (params?.id) {
                          setBook(true)
                          return
                        }
                        handleProceed()
                      }}>
                        {params?.id ? "Continue" : (isPremium ? `Pay ₹${fareValues.advanceAmount} Advance and Book` : "Continue")}
                      </button>
                    </div>
                  </>
                );
              })()}
            </div>
          </div>
        </section>
      )}
      {book && (
        <AdminPassengerDetail
          busSelect={busSelect}
          seatDetail={selectedValue?.filter((val) => val.selected == true)}
          boardingSelection={boardingSelection}
          droppingSelection={droppingSelection}
          amountVal={totalAmountCal(selectedValue)}
          handleFormClose={handleProceedClose}
          handleApiRedirect={handleApiRedirect}
          tripDetail={tripDetail}
        />
      )}
    </>
  );
};

export default AdminBoardingItem;
